<script lang="ts">
  import SupportUsBox from '$components/elements/SupportUsBox.svelte';
  import Text from '$components/utils/Text.svelte';
  import { _ } from 'svelte-i18n';
</script>

<div class="support-us-box-container">
  <SupportUsBox
    backgroundColor="#ECEBE5"
    buttonText={$_('page.club.support-us-box-container.1.button')}
    href="/klub-bible21/darujte"
  >
    <Text key="page.club.support-us-box-container.1.heading" />
  </SupportUsBox>
  <SupportUsBox
    backgroundColor="#ECEBE5"
    buttonText={$_('page.club.support-us-box-container.2.button')}
    href="/klub-bible21/registrace"
  >
    <Text key="page.club.support-us-box-container.2.heading" />
  </SupportUsBox>
</div>

<style lang="scss">
  .support-us-box-container {
    width: 80%;
    max-width: 1280px;

    align-self: center;
    display: flex;
    align-items: center;
    gap: 30px;
    margin: 32px auto;
  }

  @media screen and (max-width: 1000px) {
    .support-us-box-container {
      flex-direction: column;
      gap: 20px;
      width: 90%;
      margin-top: 24px;
    }
  }
</style>
